import { FileIcon } from "@/components/FileIcon";
import { ELESSON_DETAIL, LessonDetailBlockDto } from "@/types";
import { getFileUrl } from "@/utils";
import DOMPurify from "dompurify";

interface Props {
  block: LessonDetailBlockDto;
}

const isValidYouTubeUrl = (url: string) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
  return youtubeRegex.test(url);
};


export const LessonDetaiBlock = ({ block }: Props) => {
  const blockType = block?.content_type;

  return (
    <div className="w-[75%] mx-auto">
      {blockType === ELESSON_DETAIL.TEXT && (
        <div className="mx-auto w-4/6 2xl:w-full">
          <RenderRichText content={(block?.content as string) || ""} />
        </div>
      )}

      {blockType === ELESSON_DETAIL.IMAGE && (
        <img
          src={(block?.content as string) || ""}
          alt="image"
          className="mx-auto w-full 2xl:w-4/6 rounded-lg aspect-video bg-gray-200"
        />
      )}


      {blockType === ELESSON_DETAIL.VIDEO_YOUTUBE && isValidYouTubeUrl(block?.content as string)  && (
        <iframe
          src={(block?.content as string) || ""}
          title="video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="mx-auto w-[calc(100%+1px)] 2xl:w-4/6 aspect-video rounded-md border-none" //iframe có border thì khi hover sẽ bị lệch
        />
      )}

      {blockType === ELESSON_DETAIL.FILE && (
        <div className="mx-auto w-full 2xl:w-4/6">
          <FileIcon
            url={getFileUrl(block.content as unknown as File)?.url}
            fileName={getFileUrl(block.content as unknown as File)?.fileName}
            ext={getFileUrl(block.content as unknown as File)?.ext}
            isDownload={true}
          />
        </div>
      )}
    </div>
  );
};

const RenderRichText = ({ content }: { content: string }) => {
  const safeHTML = DOMPurify.sanitize(content, {
    USE_PROFILES: { html: true },
  });
  return (
    <div
      className="p-2 tiptap !min-h-0 !resize-none break-all whitespace-pre-wrap"
      dangerouslySetInnerHTML={{ __html: safeHTML }}
    />
  );
};
